export const hasData = (data: any): boolean => {
  if (!data) return false
  if (Array.isArray(data)) return data.length > 0
  if (typeof data === 'object') return Object.keys(data).length > 0
  if (typeof data === 'number') return data > 0
  return false
}
